import { Slide } from "react-reveal";
import scroll from "../../../../assets/images/icons/double-arrow-bottom-icon.svg";

const CaseStudyHero = (props) => {
  return (
    <section className="section-spacing-100 case-study-hero">
      <div className="container">
        <div className="large">
          <div className="section-content-container relative">
            <div className="case-study-hero-content flex">
              <div className="case-study-hero-text-side">
                <span className="case-study-client-tag">Case Study</span>
                <h1 className="case-study-title">{props.client}</h1>
                <p className="case-study-subtitle font-inter-regular">
                  {props.subtitle}
                </p>
              </div>
              <Slide top>
                <div className="case-study-hero-text-img">
                  <img
                    src={props.caseImg}
                    alt={props.client}
                  />
                </div>
              </Slide>
            </div>
            <div className="scroll-container">
              <img src={scroll} alt="Double Bottom Arrows" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CaseStudyHero;
